export type AppLoaded = boolean;

export const SET_APP_LOADED = 'SET_APP_LOADED';

export interface SetAppLoadedAction {
	type: typeof SET_APP_LOADED;
	payload: AppLoaded;
}
